import { render, staticRenderFns } from "./MiEmpresa.vue?vue&type=template&id=074d090a"
import script from "./MiEmpresa.vue?vue&type=script&lang=js"
export * from "./MiEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('074d090a')) {
      api.createRecord('074d090a', component.options)
    } else {
      api.reload('074d090a', component.options)
    }
    module.hot.accept("./MiEmpresa.vue?vue&type=template&id=074d090a", function () {
      api.rerender('074d090a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/MiEmpresa.vue"
export default component.exports